import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Rides } from '../..';
import { renderColumns } from './renderColumns';
import { renderTableHead } from './renderTableHead';
import { fetchAllTransportOrganizations } from '../../../store/transport_organizations';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';
import { setMyFilter, setFilteredStatus, getCustomUserFilter, saveCustomUserFilter } from '../../../store/rides';
import { RIDE_STATUSES } from '../../../constants/constants';
// import { buildUberNeedAttentionCountFilter } from '../../../utils/helpers';

import styles from './index.module.css';

export const transofrmOrganizationsOptions = (organizations) =>
  organizations.map((h) => ({
    key: h.id,
    title: h.name,
    value: { id: h.id, name: h.name },
    ...(h.children && {
      children: h.children.map((child) => ({
        key: child.id,
        title: child.name,
        value: { id: child.id, name: child.name },
      })),
    }),
  }));

/** Health org filter: Enterprise vs Standard sections (Figma-aligned). */
export const transformHealthOrganizationsGroupedFilter = (organizations) => {
  const enterprise = [];
  const standard = [];
  const organizationsList = organizations || [];

  const mappedChildrenByParentId = organizationsList.reduce((acc, organization) => {
    if (!organization?.parentOrgId) {
      return acc;
    }

    const childItem = {
      key: organization.id,
      title: organization.name,
      value: { id: organization.id, name: organization.name },
    };

    acc[organization.parentOrgId] = [...(acc[organization.parentOrgId] || []), childItem];
    return acc;
  }, {});

  organizationsList.forEach((h) => {
    if (!h || h.parentOrgId) return;

    const nestedChildren = h.children?.length
      ? h.children.map((child) => ({
          key: child.id,
          title: child.name,
          value: { id: child.id, name: child.name },
        }))
      : mappedChildrenByParentId[h.id] || [];

    const item = {
      key: h.id,
      title: h.name,
      value: { id: h.id, name: h.name },
      ...(nestedChildren.length && {
        children: nestedChildren,
      }),
    };

    const isEnterprise = h.isEnterprise === true || nestedChildren.length > 0;

    if (isEnterprise) enterprise.push(item);
    else standard.push(item);
  });

  return [
    { key: 'enterprise', title: 'Enterprise', children: enterprise, showNestedArrow: true },
    { key: 'standard', title: 'Standard', children: standard, showNestedArrow: false },
  ];
};

const MH_Rides = ({
  fetchAllTransportOrganizations,
  getCustomUserFilter,
  savedFilterParams,
  fetchAllHealthOrganizations,
  hasSavedFilterParams,
  transportOrganizations,
  healthOrganizations,
  setMyFilter,
  setFilteredStatus,
  isUberEligibleFromAuth,
  role,
  userRole,
}) => {
  const hasFetchedOrganizationsRef = useRef(false);
  const hasFetchedFilterRef = useRef(false);
  const isUberEligible = Boolean(isUberEligibleFromAuth);
  const setRequestsOnly = useCallback(() => {
    setMyFilter({ status: [RIDE_STATUSES.IN_PROGRESS] });
    setFilteredStatus(true);
  }, [setMyFilter, setFilteredStatus]);

  // const setNeedAttentionFilter = useCallback(() => {
  //   setMyFilter(buildUberNeedAttentionCountFilter({}));
  //   setFilteredStatus(true);
  // }, [setMyFilter, setFilteredStatus]);

  useEffect(() => {
    return () => setFilteredStatus(false);
  }, [setFilteredStatus]);

  useEffect(() => {
    if (hasFetchedOrganizationsRef.current) return;
    hasFetchedOrganizationsRef.current = true;
    fetchAllTransportOrganizations();
    fetchAllHealthOrganizations();
    
    return () => { };
  }, [fetchAllTransportOrganizations, fetchAllHealthOrganizations]);

  useEffect(() =>{ 
    if (hasFetchedFilterRef.current) return;
    hasFetchedFilterRef.current = true;
    getCustomUserFilter();

    return () => {};
  }, [getCustomUserFilter]);

  const ridesTable = useMemo(
    () => (
      <div className={styles.table}>
        <Rides
          setRequestsOnly={setRequestsOnly}
          // showNeedAttentionBtn
          // setNeedAttentionFilter={setNeedAttentionFilter}
          savedFilterParams={savedFilterParams}
          hasSavedFilterParams={hasSavedFilterParams}
          columns={renderColumns()}
          renderTableHead={renderTableHead({
            transportOrganizations: transofrmOrganizationsOptions(transportOrganizations),
            healthOrganizations: transformHealthOrganizationsGroupedFilter(healthOrganizations),
            isUberEligible
          })}
        />
      </div>
    ),
    [
      hasSavedFilterParams,
      transportOrganizations,
      healthOrganizations,
      setRequestsOnly,
      // setNeedAttentionFilter,
      savedFilterParams,
      isUberEligible,
    ],
  );
  return ridesTable;
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  transportOrganizations: state.transportOrganizations.transportOrganizations,
  savedFilterParams: state.rides?.savedFilterParams,
  hasSavedFilterParams: state.rides?.savedFilterParams && Boolean(Object.keys(state.rides?.savedFilterParams)?.length),
  isUberEligibleFromAuth: state.authorization?.isUberEligible,
  role: state.authorization?.role,
  userRole: state.authorization?.user?.role,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAllTransportOrganizations,
      setMyFilter,
      fetchAllHealthOrganizations,
      setFilteredStatus,
      getCustomUserFilter,
      saveCustomUserFilter,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MH_Rides);
